<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container shadow-md" />
    <div class="main-container">
      <div :class="{'fixed-header': fixedHeader}">
        <navbar />
      </div>
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import {mapMutations, mapState} from "vuex";
import {checkTasks, getAvailableMergeTags,
  // getCharityConfig,
  getPusher} from "@/utils/api";
import {getActiveCharity} from "@/utils/charity";
import auth from "@/auth/authService";
import {iniSegmentTracking} from "@/utils/segment";
import Vue from "vue";

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  created() {
    this.initCharity();
  },
  methods: {
    ...mapMutations('campaigns', {
      campaignsResetCache: 'resetCache',
    }),
    ...mapMutations('tasks', [
      'setTasks',
    ]),
    initCharity() {
      this.$store.dispatch('charities/fetchCharities').then((allCharities) => {
        if (!this.activeCharityId) {
          this.$store.commit('auth/SET_ACTIVE_CHARITY_ID', allCharities[0].charity_id);
        }
        else {
          this.upCharity();
        }
      });
    },
    upCharity() {
      checkTasks(this.activeCharityId).then((t) => this.setTasks(t));

      getAvailableMergeTags().then(tags => {
        const mergeTags = tags.tags.filter(
            tag => !tag.usage.includes('has_donated') && !tag.usage.includes('has_not_donated'));

        window.mergeTags = mergeTags;
        this.$root.mergeTags = mergeTags;
      });

      this.$store.dispatch('messages/updateThreads', {charity_id: this.activeCharityId}, {root: true});


      //pusher
      if (this.pusher) {
        this.pusher.disconnect();
      }
      this.pusher = getPusher();

      this.channel = this.pusher.subscribe(`private-${this.activeCharityId}`);

      this.channel.bind('inbound-sms', (message) => this.newMsgEvent(message));

      this.channel.bind('client-admin-message', (message) => this.newMsgEvent(message));

      this.$store.dispatch('donors/fetchAllDonors', {charityId: this.activeCharityId});

      this.$store.dispatch('donations/fetchAllDonations', {charityId: this.activeCharityId});

      this.$store.dispatch('auth/fetchProfileSettings', {charityId: this.activeCharityId});

      Promise.all([
        this.$store.dispatch('charities/fetchCharityConfig', {charityId: this.activeCharityId}),
        this.$store.dispatch('auth/fetchProfileSettings', {charityId: this.activeCharityId})
      ]).then(([charityInfo]) => {

        const activeCharity = getActiveCharity(this.allCharities);

        const tokenData = auth.getToken().split('.');
        const data = JSON.parse(atob(tokenData[1]));


        // Each client will be identified by their numeric ID and the charity ID.
        // This makes sure there is one "user" per client per charity,
        //   even if a client is a member of multiple charities.
        let analyticsId = this.adminInfo.id + '-' + activeCharity.charity_id;

        if (typeof Appcues != 'undefined') {
// eslint-disable-next-line
          Appcues.identify(analyticsId, {
            created: data['iat'] || '',
            fullName: (data['fname'] + ' ' + data['lname']) || '',
            email: data['client_email'] || '',
            organization: activeCharity.name || '',
          });
        }

        let isGodAdmin = false;

        if (data && data.client_id && data.client_id.search('god_admin_') === 0) {
          isGodAdmin = true;
        }

        if(!isGodAdmin) {
          iniSegmentTracking().then(() => {

            // eslint-disable-next-line
            analytics.identify(
                analyticsId, {
                  client_id: data['client_id'],
                  first_name: data['fname'],
                  last_name: data['lname'],
                  email: data['client_email'],
                  phone_number: this.adminInfo.details && this.adminInfo.details.phone_number || '',
                  position: this.adminInfo.details && this.adminInfo.details.role || '',
                  domain: charityInfo.subdomain,
                  charity_id: activeCharity.charity_id,
                  charity_name: activeCharity.name,
                  logins: this.allCharities.length,
                }, {
                  context: {
                    groupId: activeCharity.charity_id,
                  },
                },
            );
          })

          Vue.loadScript('https://cdn.vitally.io/vitally.js/v1/vitally.js').then(() => {
            window.Vitally.init('ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SmhkV1FpT2lJeE1qYzBNVFUzWkMwM01tTTNMVFE0TWpFdFlUZGtZeTFpTldReU9UVmpNRFZpTmpNaUxDSmhjR2tpT2lKaGNHa2lMQ0p6WldNaU9pSmpOR0l4Tm1Wa05pSjkucEZtMll2RWw5THZ6c2EweGc0OGxUYUtVS3RwSHZJZXQyLUVKRE5KQnEzbzo=');

            // eslint-disable-next-line
            window.Vitally.account({
              accountId: activeCharity.charity_id,
              traits: {
                name: activeCharity.activeCharity, // required
              },
            });

// eslint-disable-next-line
            window.Vitally.user({
              userId: analyticsId,
              accountId: activeCharity.charity_id, // Sending accountId is optional if you've already called Vitally.account, but it's always best to be explicit :)
              traits: {
                name: `${this.adminInfo.first_name} ${this.adminInfo.last_name}`,
                email: this.adminInfo.email,
                avatar: this.adminInfo.profile_photo, // optional, but makes Vitally look prettier :)
                // Add any other traits here you'd like to attach to your users in Vitally
              },
            });

// eslint-disable-next-line
            window.Vitally.nps('survey', {
              productName: 'Harness',
              delay: 1000,
              primaryColor: '#0d70e3',
              npsQuestion: '👋 Quick Question - How likely would you be to recommend Harness to a friend or colleague?',
              followUpTitle: 'Thanks for your feedback! 📬 ',
              followUpSubtitle: 'Would you mind sharing some additional specifics? 📝',
              thanksTitle: 'You rock 🤘 Thanks for sharing that with us!',
              thanksSubtitle: 'Bye for now 👋🏼 Let us know if you need anything ',
            });
          });

        }

      });
    },
    addNewMessage(msg) {
      this.$store.dispatch(
          'messages/newMessage',
          {message: msg, charity_id: this.activeCharityId},
          {root: true},
      );

      this.$store.commit('messages/markAsRead', {
        uid: msg.uid,
        charity_id: this.activeCharityId,
      });

      const newMsg = Object.assign({}, msg);
      delete newMsg.is_read;
      this.channel.trigger('client-admin-message', newMsg);
    },
    newMsgEvent(msg) {
      if (!msg || !msg.uid) {
        return false;
      }

      msg['id'] = msg['id'] || Math.floor(Math.random() * 10000000) + 11100000000;
      msg['body'] = msg['body'] || msg['message'];
      msg['direction'] = ('direction' in msg) ? msg['direction'] : 'inbound';//outbound
      msg['client'] = ('client' in msg) ? msg['client'] : null;
      msg['timestamp'] = msg['timestamp'] || new Date().toISOString();
      msg['is_read'] = msg['is_read'] || false;

      this.$store.dispatch(
          'messages/newMessage',
          {message: msg, charity_id: this.activeCharityId},
          {root: true},
      );
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  },
  computed: {
    ...mapState({
      allCharities: state => state.charities.charities,
      activeCharityId: state => state.auth.activeCharityId,
      adminInfo: state => state.auth.adminInfo,

      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
    }),
    fixedHeader() {
      return true;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  watch: {
    'activeCharityId'() {
      this.campaignsResetCache();

      this.$store.commit('donations/RESET_STATE');
      this.$store.commit('donors/RESET_STATE');
      this.$store.commit('roundUps/RESET_STATE');
      this.$store.commit('lists/RESET_STATE');

      this.$nextTick(() => {
        this.upCharity();
      });

    },
  },

}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2000;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;

    &:before{
      content: ' ';
      display: block;
      width: 10px;
      height: 100%;
      margin-left: -4px;
      background-color: white;
      position: absolute;
      z-index: 1000000;
    }
  }



  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
